import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { ThemeService } from 'src/app/theme.service';

@Component({
    selector: 'theme-selector',
    templateUrl: 'theme-selector.component.html',
    styleUrls: ['./theme-selector.component.scss']
  })
   
  export class ThemeSelectorComponent {
    currentTheme
    themeSource

     cdcsetting : boolean = false;
    constructor(private theme: ThemeService) {
        this.currentTheme = theme.getTheme()
        this.themeSource = theme.getThemeData()
          const setting = localStorage.getItem('cdcSetting');
this.cdcsetting = setting !== null ? JSON.parse(setting) : false; 
      if(this.cdcsetting){
         this.theme.applyTheme("purple.light")

      }
    }
    onValueChanged(e: any){
      debugger
        this.theme.applyTheme(e.value)
    }
  
  }
  
  @NgModule({
    imports: [
      CommonModule,
      DxSelectBoxModule,
      DxTextBoxModule
    ],
    declarations: [ ThemeSelectorComponent ],
    exports: [ ThemeSelectorComponent ]
  })
  export class ThemeSelectorModule { }